import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class FilterButtons extends Component {
  static propTypes = {
    filterType: PropTypes.func.isRequired,
    filterBedrooms: PropTypes.func.isRequired,
    filterBudget: PropTypes.func.isRequired,
    showAllFilters: PropTypes.func.isRequired,
    resetAllFilters: PropTypes.func.isRequired,

  }

  filterType = () => this.props.filterType()
  filterBedrooms = () => this.props.filterBedrooms()
  filterBudget = () => this.props.filterBudget()
  showAllFilters = () => this.props.showAllFilters()

  resetAllFilters = () => this.props.resetAllFilters()

  render () {
      let resetAllFiltersButtonStyle = {margin: '15px'}

    return (
      <div className='filters'>
        <div className='hidden-mobile'>
          <button  onClick={this.resetAllFilters} style={resetAllFiltersButtonStyle} className='btn btn--small btn--secondary btn--outline' >
            Reset All Filters
          </button>
          <div className='filters__title hidden-tablet'>Filters:&nbsp;</div>
          <button className='btn btn--small btn--secondary btn--outline' onClick={this.filterType}>
            Type
          </button>
          <button className='btn btn--small btn--secondary btn--outline' onClick={this.filterBedrooms}>
            Bedrooms
          </button>
          <button className='btn btn--small btn--secondary btn--outline' onClick={this.filterBudget}>
            Budget
          </button>
          <button className='btn btn--small btn--secondary btn--outline' onClick={this.showAllFilters}>
            All filters
          </button>
        </div>

        <button onClick={this.showAllFilters} className='btn btn--secondary btn--outline btn--icon mobile-filter-button hidden-tablet hidden-laptop hidden-desktop'>
          <span className='sr-only'>Filters</span>
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterButtons.js